import { createVNode as o, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/HomepageFilledStandard.js";
import m from "../components/PfIcon.js";
const e = (r, t) => {
  const a = {
    ...r,
    ...t.attrs
  };
  return o(m, d(a, {
    icon: l
  }), null);
};
e.displayName = "HomepageFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
